<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/28/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/28/title-1.png" alt="" />
                    <div class="content">
                        成华区内由高技能人才依托区内企事业单位、职业院校（培训学校）为载体领办（创办）或单独领办（创办）的，技能含量较高，旨在服务于生产、研发、教学、实训等的专门场所。
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/28/title-2.png" alt="" />
                    <div class="content">
                        <div style="font-size: 0.32rem; font-weight: 600">
                            <span class="hollow-cricle"></span> （一）
                            创办工作室的单位：注册、经营地址和企业税收解缴关系均在成华区，有较为完善的技能人才培养、评价、选拔、使用和激励制度，为技能大师工作室提供相应的资金支持以及固定的培训、交流、展示、活动场地、设备等必要的工作条件。
                        </div>
                        <div style="
                                                font-size: 0.32rem;
                                                font-weight: 600;
                                                margin-top: 0.25rem;
                                            ">
                            <span class="hollow-cricle"></span>
                            （二）技能大师：在新技术、新工艺、新产品的研发中发挥重要作用，并符合下列条件之一：
                        </div>
                        <div class="des">
                            <div class="item">
                                <div class="dot">1</div>
                                具有国家二级（技师）及以上职业资格水平的高技能人才。
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                获得“中华技能大奖”，市级及以上“政府特殊津贴”“杰出创新人才奖”“技术能手”等任一荣誉称号的优秀高技能人才。
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                获得“成华工匠”荣誉称号的优秀高技能人才。
                            </div>
                            <div class="item">
                                <div class="dot">4</div>
                                掌握民间传统技能、绝招绝技，获得市级及以上“工艺美术大师”等其他相应称号的技艺人才。
                            </div>
                        </div>
                        <div style="
                                                font-size: 0.32rem;
                                                font-weight: 600;
                                                margin-top: 0.25rem;
                                            ">
                            <span class="hollow-cricle"></span>
                            （三）同一单位可申报多个不同职业工种技能大师工作室。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/28/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            （一）给予成华区技能大师工作室建设单位一次性10万元补助资金。
                        </div>
                        <div class="des">
                            （二）已获批的成华区技能大师工作室，择优推荐参加成都市技能大师工作室评选，对成功获批国家、四川省、成都市技能大师工作室的，除获得国家、省、市奖励资金外，区财政在认定当年再匹配10万元补助资金。
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/28/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="dot">1</div>
                                <div class="line"></div>
                                印发申报通知
                            </div>
                            <div class="line-item">
                                <div class="dot">2</div>
                                <div class="line"></div>
                                自主申报
                            </div>
                            <div class="line-item">
                                <div class="dot">3</div>
                                <div class="line"></div>
                                属地初审
                            </div>
                            <div class="line-item">
                                <div class="dot">4</div>
                                <div class="line"></div>
                                汇总审核
                            </div>
                            <div class="line-item">
                                <div class="dot">5</div>
                                <div class="line"></div>
                                实地考察
                            </div>
                            <div class="line-item">
                                <div class="dot">6</div>
                                <div class="line"></div>
                                审定公示
                            </div>
                            <div class="line-item">
                                <div class="dot">7</div>
                                确定最终人选
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-84310100">028-84310100</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成华区人社局
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/28/code.png" />
                    <img class="text" src="../assets/imgs/28/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                font-size: 0.26rem;
                color: #333333;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                text-align: left;
                line-height: 0.44rem;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;
            line-height: 0.44rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.35rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;

                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;
            line-height: 0.44rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;
                        padding-left: 0.5rem;
                        box-sizing: border-box;
                        margin-bottom: 0.35rem;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            z-index: 0;
                            top: 0.2rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.94rem;
            }
        }
    }
}
</style>
